import { useContext, useEffect, useRef } from 'react';
import { MainContext } from '..';
import { observer } from 'mobx-react-lite';
import { observable } from 'mobx';

export const useWebSocketUpdations = (patientId, setIndicatorUpdate, setSpo2Update) => {
    const { ws } = useContext(MainContext);
    // Установка значений, получаемых по вебсокету
    useEffect(() => {
        // console.log('[ws.indicatorUpdate]');
        if (patientId === ws.indicatorUpdate?.patient) {
            console.log(`indicatorUpdate pId=${patientId}`, ws.indicatorUpdate);
            setIndicatorUpdate(ws.indicatorUpdate);
        }
    }, [ws.indicatorUpdate]);

    // useRandomUpdations(patientId, setIndicatorUpdate, setSpo2Update)

    useEffect(() => {
        // console.log('[ws.spo2Update]');
        // console.log(patientId, ws.spo2Update?.spO2_value);
        if (patientId === ws.spo2Update?.patient_id) {
            console.log(`spo2Update pId=${patientId}`, ws.spo2Update);
            setSpo2Update(ws.spo2Update);
        }
    }, [ws.spo2Update]);
};

const useRandomUpdations = (patientId, setIndicatorUpdate, setSpo2Update) => {
    const intervalRef = useRef(null);

    useEffect(() => {
        const generateDataPoint = () => {
            const now = new Date();

            // Генерация случайного pulse (например, от 90 до 100)
            const pulse = Math.floor(Math.random() * 10) + 90;

            // Генерация случайного respiratory_rate (например, от 20 до 25)
            const respiratory_rate = Math.floor(Math.random() * 5) + 20;

            // Генерация случайного saturation (например, от 95 до 100)
            const saturation = Math.floor(Math.random() * 5) + 95;

            // Генерация случайного saturation (например, от 60 до 100)
            const oxygen_flow = Number((Math.random() * 2 + 2).toFixed(1));

            // Форматирование timestamp с микросекундами
            const timestamp =
                now.toISOString().slice(0, -1) +
                String(now.getMilliseconds()).padStart(3, '0') +
                'Z';

            const indicator = {
                id: 0,
                patient: patientId, // ID пациента, для которого это обновление
                pulse: pulse,
                respiratory_rate: respiratory_rate,
                saturation: saturation,
                oxygen_flow: oxygen_flow,
                timestamp: timestamp,
            };
            // console.log(indicator);
            setIndicatorUpdate(indicator);
        };

        // Запускаем генератор каждую секунду
        intervalRef.current = setInterval(generateDataPoint, 1000);

        // Очистка при размонтировании
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);
};

